<template>
    <v-app-bar app class="indigo darken-1" dark>
      <v-app-bar-nav-icon @click="toggleNavigationBar"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <span class="font-weight-bold font-weight-black title">{{name}}</span>
      </v-toolbar-title>
      <v-spacer />
      <breadcrumbs />
      <v-divider class="mx-1" vertical />
      <div class="mr-2">
        <v-btn @click="menu()" fab icon>
          <v-icon>mdi-logout-variant</v-icon>
        </v-btn>
      </div>
    </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import router from '@/router'
export default {
  props: ['name'],
  data () {
    return {}
  },
  methods: {
    ...mapActions(['getUrlServices', 'urlPostServiceLogoutAction']),
    toggleNavigationBar () {
      const vm = this
      vm.$emit('toggleNavigationBar')
    },
    menu () {
      this.$swal.fire({
        title: '¿Desea cerrar su sesion ?',
        text: 'Asegurese de haber concluido sus labores diarias',
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Cerrar sesion',
        cancelButtonText: 'Cancelar'
      }).then(result => {
        if (result.value) {
          this.getUrl('GET/config/auth/usuarios/logout')
        }
      })
    },
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.urlPostServiceLogoutAction({ url: router })
      } else {
        this.getUrlServices()
      }
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objectCloseAccess'])
  },
  watch: {
    get_objectCloseAccess (val) {
      if (val.result) {
        this.$cookies.remove('token_sirh')
        this.$cookies.remove('token_user')
        router.push('/')
      }
    }
  }
}
</script>
